import './tokens.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, createCognitoAuthClient } from '@scoring/frontend-shared';
import type { AuthClient } from '@scoring/frontend-shared';
import { App } from './App.js';

async function enableMocking(): Promise<void> {
  if (import.meta.env.DEV) {
    const { startMockWorker } = await import('@scoring/mocks');
    await startMockWorker();
  }
}

await enableMocking();

async function getAuthClient(): Promise<AuthClient> {
  if (import.meta.env.DEV) {
    const { createMockAuthClient } = await import('@scoring/mocks');
    return createMockAuthClient();
  }
  return createCognitoAuthClient({
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
  });
}

const authClient = await getAuthClient();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider authClient={authClient}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
